<div class="tracking-container">
 <div class="tracking-header">
    <h2>法規追蹤改善事項</h2>
    <div class="tracking-actions" style="margin-left: auto">
      <button class="btn-export"
              (click)="exportSelectedItems()"
              [disabled]="isExporting || getSelectedCount() === 0">
        <i class="fa-solid" [ngClass]="{'fa-file-export': !isExporting, 'fa-spinner fa-spin': isExporting}"></i>
        {{ isExporting ? '匯出中...' : '匯出 Excel' }}
        <span *ngIf="!isExporting && getSelectedCount() > 0" class="badge">{{ getSelectedCount() }}</span>
      </button>
      <button class="btn-import" (click)="openComplianceImportModal()">
        <i class="fa-solid fa-file-import"></i> 從合規判斷匯入
        <span class="badge">{{ availableComplianceItems }}</span>
      </button>
    </div>
    <div class="tracking-actions">
      <button (click)="openAddItemModal()" class="btn-add">
        <i class="fa-solid fa-plus"></i> 新增追蹤項目
      </button>
    </div>
  </div>

  <!-- 過濾與排序工具列 -->
  <div class="tracking-toolbar">
    <div class="filter-group">
      <label for="filterStatus">狀態：</label>
      <select id="filterStatus" [(ngModel)]="filterStatus">
        <option *ngFor="let option of filterStatusOptions" [value]="option.value">
          {{ option.key }}
        </option>
      </select>
    </div>

    <div class="filter-group">
      <label for="filterPriority">優先級：</label>
      <select id="filterPriority" [(ngModel)]="filterPriority">
        <option value="all">全部</option>
        <option value="high">高</option>
        <option value="medium">中</option>
        <option value="low">低</option>
      </select>
    </div>

    <div class="filter-group">
      <label for="sortBy">排序：</label>
      <select id="sortBy" [(ngModel)]="sortBy">
        <option value="dueDate">截止日期</option>
        <option value="priority">優先級</option>
      </select>
    </div>

    <div class="select-all">
      <label>
        <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()"> 全選/取消全選
      </label>
      <span *ngIf="getSelectedCount() > 0" class="selected-count">
        已選擇 {{ getSelectedCount() }} 項
      </span>
    </div>
  </div>

  <!-- 追蹤項目列表 -->
  <div class="tracking-list" style="overflow-x: auto;">
    <table>
      <thead>
        <tr>
          <th class="col-select text-center">選擇</th>
          <th class="col-actions text-center">操作</th>
          <th class="col-index">項次</th>
          <th class="col-status">狀態</th>
          <th class="col-priority">優先級</th>
          <th class="col-topic">主題</th>
          <th class="col-title" style="min-width: 150px;">任務名稱</th>
          <th class="col-regulation-name" style="min-width: 200px;">法規名稱</th>
          <th class="col-article">條次</th>
          <th class="col-article-desc" style="min-width: 320px;">條文說明</th>
          <th class="col-current-situation">現況說明</th>
          <th class="col-risk-opportunity">風險/機會</th>
          <th class="col-solution">解決方案</th>
          <th class="col-improvement">改善內容</th>
          <th class="col-assignee">負責部門/負責人</th>
          <th class="col-duedate">截止日期</th>
          <th class="col-remark">備註</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let item of filteredItems; let i = index"
          [class.editing]="editingItemId === item.id"
        >
          <ng-container *ngIf="editingItemId !== item.id">
            <td class="col-select text-center">
              <input type="checkbox" [checked]="item.selected" (change)="toggleSelectItem(item)">
            </td>
            <td class="col-actions text-center">
              <button (click)="openEditItemModal(item)" class="btn-edit" title="編輯">
                <i class="fa-solid fa-edit"></i>
              </button>
            </td>
            <td class="col-index text-center">{{ i + 1 }}</td>
            <td class="col-status">{{ getStatusDisplayText(item.status) }}</td>
            <td class="col-priority">{{ item.priority}}</td>
            <td class="col-topic">{{ item.topic  }}</td>
            <td class="col-title">{{ item.title}}</td>
            <td class="col-regulation-name">{{ item.law_name }}</td>
            <td class="col-article">{{ item.article_no }}</td>
            <td class="col-article-desc">
              <span [title]="item.article_content">
                {{ item.article_content && item.article_content.length > 40 ? (item.article_content | slice:0:40) + '...' : item.article_content }}
              </span>
            </td>
            <td class="col-current-situation">{{ item.current_status }}</td>
            <td class="col-risk-opportunity">
              <ng-container *ngIf="item.riskOpportunity?.length">
                <span *ngFor="let ro of item.riskOpportunity; let last = last">{{ ro }}<span *ngIf="!last">, </span></span>
              </ng-container>
            </td>
            <td class="col-solution">
              <ng-container *ngIf="item.solution?.length">
                <span *ngFor="let sol of item.solution; let last = last">{{ sol }}<span *ngIf="!last">, </span></span>
              </ng-container>
            </td>
            <td class="col-improvement">{{ item.improvementContent }}</td>
            <td class="col-assignee">{{ item.assignee }}</td>
            <td class="col-duedate">
              <span [ngClass]="{'overdue': isDueDateOverdue(item.dueDate)}">{{ item.dueDate }}</span>
            </td>
            <td class="col-remark">{{ item.improvementContent }}</td>
          </ng-container>
        </tr>
      </tbody>
    </table>

    <!-- 空列表提示 -->
    <div class="empty-list" *ngIf="filteredItems.length === 0">
      目前沒有符合條件的追蹤項目
    </div>
  </div>
</div>

<!-- 新增/編輯項目的全螢幕彈出視窗 -->
<div class="modal-overlay" *ngIf="showItemModal" (click)="onModalBackdropClick($event)">
  <div class="modal-container" [class.edit-mode]="isEditMode">
    <div class="modal-header">
      <h2>{{ isEditMode ? '編輯追蹤項目' : '新增追蹤項目' }}</h2>
      <button class="modal-close" (click)="closeItemModal()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-section">
        <h3>基本資訊</h3>
        <div class="form-row">
          <div class="form-group" style="flex: 3">
            <label for="itemRegulationName">法規名稱</label>
            <input type="text" id="itemRegulationName" [(ngModel)]="currentItem.law_name" placeholder="請輸入法規名稱">
          </div>
          <div class="form-group" style="flex: 1">
            <label for="itemArticle">條次</label>
            <input type="text" id="itemArticle" [(ngModel)]="currentItem.article_no" placeholder="請輸入條次">
          </div>
        </div>
          <div class="form-row">
  <div class="form-group">
            <label for="itemArticleDesc">條文說明</label>
            <textarea type="text" id="itemArticleDesc" [(ngModel)]="currentItem.article_content" placeholder="請輸入條文說明"cols="5"></textarea>
          </div>
          </div>
        <div class="form-row">
          <div class="form-group">
            <label for="itemCurrentSituation">現況說明</label>
            <textarea type="text" id="itemCurrentSituation" [(ngModel)]="currentItem.current_status" placeholder="請輸入現況說明" cols="5"></textarea>
          </div>


        </div>

      </div>

      <div class="form-section">
        <h3>負責人與時程</h3>
        <div class="form-row">
          <div class="form-group">
            <label for="itemAssigneeName">負責人</label>
            <input type="text" id="itemAssigneeName" [(ngModel)]="currentItem.assignee" placeholder="請輸入負責人姓名">
          </div>

          <div class="form-group">
            <label for="itemAssigneeEmail">負責人信箱</label>
            <select id="itemAssigneeEmail" [(ngModel)]="currentItem.email" required>
              <option value="" disabled selected>請選擇負責人信箱</option>
              <option *ngFor="let user of users" [value]="user.email">
                {{user.username}}({{user.email}})
              </option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="itemStatus">狀態</label>
            <select id="itemStatus" [(ngModel)]="currentItem.status">
              <option value="" disabled selected>請選擇狀態</option>
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.key }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="itemPriority">優先級</label>
            <select id="itemPriority" [(ngModel)]="currentItem.priority">
              <option value="" disabled selected>請選擇優先級</option>
              <option value="低">低</option>
              <option value="中">中</option>
              <option value="高">高</option>
            </select>
          </div>

          <div class="form-group">
            <label for="itemDueDate">截止日期 </label>
            <input type="date" id="itemDueDate" [(ngModel)]="currentItem.dueDate" required>
          </div>
        </div>
      </div>

       <div class="form-row">


       </div>

      <div class="form-section">
        <h3>改善計畫與相關佐證</h3>
   <div class="form-row">
               <div class="form-group">
            <label>風險/機會 </label>
            <div class="checkbox-group">
              <label *ngFor="let opt of riskOpportunityOptions">
                <input type="checkbox"
                       [checked]="isRiskOpportunitySelected(opt)"
                       (change)="toggleRiskOpportunity(opt)">
                {{ opt }}
              </label>
            </div>
          </div>
          <div class="form-group" style="flex-basis: 100%;">
            <label>解決方案</label>
            <div class="checkbox-group">
              <label *ngFor="let opt of solutionOptions">
                <input type="checkbox"
                       [checked]="isSolutionSelected(opt)"
                       (change)="toggleSolution(opt)">
                {{ opt }}
              </label>
            </div>
          </div>
</div>

          <div class="form-row">
          <div class="form-group ull-width">
            <label for="itemImprovementContent">改善內容</label>
            <textarea type="text" id="itemImprovementContent" [(ngModel)]="currentItem.improvementContent" placeholder="請輸入改善內容" rows="5"></textarea>
          </div>
          </div>
          <div class="form-row">
            <div class="form-group ull-width">
              <label for="itemAttachments">附檔上傳</label>
              <input
                type="file"
                id="itemAttachments"
                (change)="onFilesSelected($event)"
                multiple
                accept="*"
              />
              <div class="attachment-list" *ngIf="currentItem.attachments?.length">
                <ul>
                  <li *ngFor="let file of currentItem.attachments; let i = index">
                    {{ file.name }}
                    <button type="button" (click)="removeAttachment(i)" title="移除">移除</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="left-actions">
        <button *ngIf="isEditMode" class="btn-delete-item" (click)="confirmDelete(currentItem)">
          <i class="fa-solid fa-trash"></i> 刪除項目
        </button>
        <button *ngIf="isEditMode && currentItem.status === 'review'" class="btn-review-item" (click)="openReviewModal(currentItem)">
          <i class="fa-solid fa-check-circle"></i> 審核
        </button>
      </div>
      <div class="modal-actions">
        <button class="btn-cancel" (click)="closeItemModal()">取消</button>
        <button class="btn-save" (click)="saveItem()">
          {{ isEditMode ? '儲存變更' : '新增項目' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 刪除確認對話框 -->
<div class="confirm-delete-overlay" *ngIf="showDeleteConfirm" (click)="cancelDelete($event)">
  <div class="confirm-delete-modal">
    <div class="confirm-delete-header">
      <h3>確認刪除</h3>
    </div>
    <div class="confirm-delete-body">
      <p>您確定要刪除此法規追蹤項目嗎？此操作不可復原。</p>
      <div *ngIf="itemToDelete">
        <p><strong>法規名稱：</strong> {{itemToDelete.law_name || '未指定'}}</p>
        <p><strong>條次：</strong> {{itemToDelete.article_no || '未指定'}}</p>
      </div>
    </div>
    <div class="confirm-delete-footer">
      <button class="btn-cancel" (click)="cancelDelete()">取消</button>
      <button class="btn-confirm-delete" (click)="deleteItem()">確認刪除</button>
    </div>
  </div>
</div>

<!-- 發送通知確認對話框 -->
<div class="confirm-email-overlay" *ngIf="showEmailConfirm" (click)="cancelEmailConfirm($event)">
  <div class="confirm-email-modal">
    <div class="confirm-email-header">
      <h3>確認發送通知</h3>
    </div>
    <div class="confirm-email-body">
      <p>是否要發送通知信給負責人 <strong>{{ currentItem.assignee }}</strong>？</p>
      <p *ngIf="currentItem.email"><strong>信箱：</strong> {{ currentItem.email }}</p>
    </div>
    <div class="confirm-email-footer">
      <button class="btn-cancel" (click)="cancelEmailConfirm()">否，不發送</button>
      <button class="btn-confirm-email" (click)="confirmSendEmail()">是，發送通知</button>
    </div>
  </div>
</div>

<!-- 審核確認對話框 -->
<div class="confirm-review-overlay" *ngIf="showReviewConfirm" (click)="cancelReview($event)">
  <div class="confirm-review-modal">
    <div class="confirm-review-header">
      <h3>確認審核</h3>
    </div>
    <div class="confirm-review-body">
      <p>確認要審核此改善項目嗎？</p>
      <div *ngIf="itemToReview">
        <p><strong>法規名稱：</strong> {{itemToReview.law_name || '未指定'}}</p>
        <p><strong>條次：</strong> {{itemToReview.article_no || '未指定'}}</p>
        <p><strong>負責人：</strong> {{itemToReview.assignee || '未指定'}}</p>
        <p *ngIf="itemToReview.check_result_id"><strong>來源資料ID：</strong> {{itemToReview.check_result_id}}</p>
        <div *ngIf="itemToReview.improvementContent" class="improvement-content-display">
          <p><strong>改善內容：</strong></p>
          <div class="improvement-content-text">{{itemToReview.improvementContent}}</div>
        </div>
      </div>

      <div class="review-comment-section">
        <label for="reviewComment">審核意見：</label>
        <textarea
          id="reviewComment"
          [(ngModel)]="reviewComment"
          placeholder="請輸入審核意見..."
          rows="3"
          class="review-comment-textarea">
        </textarea>
      </div>

      <div class="compliance-correction-section" *ngIf="itemToReview?.check_result_id">
        <div class="checkbox-wrapper">
          <input
            type="checkbox"
            id="syncComplianceCorrection"
            [(ngModel)]="syncComplianceCorrection"
            (change)="onSyncComplianceCorrectionChange()"
            class="compliance-checkbox">
          <label for="syncComplianceCorrection">同步將此項鑑別結果修正成符合</label>
        </div>

        <div class="compliance-status-input" *ngIf="syncComplianceCorrection">
          <label for="complianceStatusMessage">符合性判別資訊：</label>
          <textarea
            id="complianceStatusMessage"
            [(ngModel)]="complianceStatusMessage"
            placeholder="請輸入要寫在符合性判別的資訊..."
            rows="3"
            class="compliance-status-textarea">
          </textarea>
        </div>
      </div>
    </div>
    <div class="confirm-review-footer">
      <button class="btn-cancel" (click)="cancelReview()">取消</button>
      <button class="btn-confirm-review" (click)="confirmReview()">
        <i class="fa-solid fa-check"></i> 確認審核
      </button>
    </div>
  </div>
</div>

<app-compliance-import
  [show]="showComplianceImportModal"
  [companyId]="companyid"
  [items]="unfitItems"
  (close)="closeComplianceImportModal()"
  (itemsImported)="onItemsImported($event)">
</app-compliance-import>


